export default class SomethingPersonModel {
  constructor(
    public id: number,
    public firstName: string,
    public lastName: string,
    public age: number
  ) {}
}
